<template>
    <div :class="['grid-x', 'page-header-container', 'hide-for-large', 'align-center-middle', {minified}, {'sticky-header': hasStickyContent}]" ref="page-header-container">
        <div class="cell shrink logo-container">
            <router-link :to="{name: 'food'}" class="navbar-logo">
                <img :src="storeLogo" alt="Store Logo"/>
            </router-link>
        </div>
        <div class="cell auto flex-container align-center-middle page-header-time-container">
            <pickup-time-modal dusk="mobile-pickup-time-modal"></pickup-time-modal>
        </div>
        <div class="cell shrink flex-container align-center-middle header-action" v-if="hasHeaderAction">
            <slot name="header-action"/>
        </div>
        <div class="cell sticky-container">
            <slot name="sticky"/>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PickupTimeModal from '@/components/front/time-scheduler/PickupTimeModal.vue';
import { Icon } from '@/front/icons';
import Settings, { SettingNamespace } from '@/utils/settings';
import { registerScrollCallback, removeScrollCallback } from '@/utils/scroll-event-manager';


@Component({
    components: { PickupTimeModal }
})
export default class MobileHeader extends Vue
{
    @Prop(String) readonly title!: string;

    storeLogo: string = "";
    minified: boolean = false;
    prevScrollTop: number = 0;

    async created() {
        const settings = await Settings.getInstance();
        this.storeLogo = settings.get(SettingNamespace.GENERAL, 'store_logo')?.value;
    }

    mounted() {
        registerScrollCallback('mobile-header', this.onScroll);
    }

    onScroll(pageContentContainer: HTMLElement) {
        this.minified = (pageContentContainer.scrollTop > 20);
    }

    get hasHeaderAction() {
        return !!this.$slots['header-action'];
    }

    get hasStickyContent() {
        return !!this.$slots['sticky'];
    }

    get Icon() {
        return Icon;
    }

    destroyed() {
        removeScrollCallback('mobile-header');
    }
}

</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.page-header-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 15px 0px 20px;
    background: var(--navbar-bg);
    z-index: 11;
    transition: top .5s, padding .3s;
    color: var(--navbar-link-color);

    &.minified {
        box-shadow: 0 1px 3px 0 rgba(0,0,0,.2);
        padding-bottom: 10px;
        padding-top: 10px;
    }

    &.sticky-header {
        padding-bottom: 0;
    }

    .sticky-container {
        margin-top: 15px;
        transition: margin ease 0.3s;
    }

    &.minified {
        .sticky-container {
            margin-top: 10px;
        }
    }

    .header-action {
        path {
            fill: var(--navbar-link-color);
        }
    }

    .logo-container, .header-action {
        padding: 0px 15px;

        img {
            max-height: 48px;
        }

        @media screen and (max-width: 320px) {
            padding: 0px 10px;
        }
    }
}


.page-header-fade-enter-active {
  transition: opacity .5s;
}
.page-header-fade-leave-active {
  transition: opacity 0s;
}
.page-header-fade-enter, .page-header-fade-leave-to {
  opacity: 0;
}
</style>

